import React from "react";
import ResponsiveComponent from "../common/ResponsiveComponent";
import MobileBackButton from "./mobile/BackButton";
import WebBackButton from "./web/BackButton";

interface BackButtonProps {
  text: string;
  onClick?: () => void; // Optional onClick handler for custom behavior
}

const BackButton: React.FC<BackButtonProps> = ({ text, onClick }) => {
  return (
    <ResponsiveComponent
      mobileComponent={<MobileBackButton text={text} onClick={onClick} />}
      webComponent={<WebBackButton text={text} onClick={onClick} />}
    />
  );
};

export default BackButton;
